var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btnBox ft16 row cen-center gray-6",class:{'btnOrgin':_vm.btnCol}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }